// extracted by mini-css-extract-plugin
export var compactFilters = "_ch-4";
export var detailImage = "_ch-1";
export var dropdownContainer = "_ch-2";
export var imageContainer = "_ch-0";
export var selectedCard = "_ch-3";